import { Image } from '@round/ui-kit';
import { ReactComponent as TiktokIcon } from '../../../../../assets/TiktokIcon.svg';
import { ReactComponent as InstagramIcon } from '../../../../../assets/InstagramIcon.svg';
import styles from './BookingCartItemRow.module.css';
import cn from 'classnames';
import React from 'react';
import { BookingCartItem, PriceOffer } from '../../useClientBookingData';
import { formatNumberToKNotation } from '../../../../../utils/valueFormatHelpers';
import useNonNullContext from '../../../../../hooks/useNonNullContext';
import { OptionsContext } from '../../../../../contexts/OptionsContext';
import { ClientInfluencerUserImage } from '../../ClientBookingContext/reducer';

export type BookingCartItemRowProps = {
    cartItem: BookingCartItem;
    influencerImage: ClientInfluencerUserImage | undefined;
    currencyId: number | undefined;
    setPriceOffer?: (offer: PriceOffer) => void;
    readOnly?: boolean;
};

const BookingCartItemRow = ({
    cartItem,
    influencerImage,
    readOnly,
    setPriceOffer,
    currencyId,
}: BookingCartItemRowProps) => {
    const inputRef = React.useRef<HTMLInputElement>(null);
    const { currencies } = useNonNullContext(OptionsContext);

    const PlatformIcon = cartItem.platform === 'TIKTOK' ? TiktokIcon : InstagramIcon;
    const currencySymbol = currencies.find((c) => c.id === currencyId)?.symbol ?? '';
    const isOfferExists = inputRef.current && inputRef.current?.value !== '';

    const name = cartItem.name ?? '-';
    const followers = cartItem.followers ? `${formatNumberToKNotation(cartItem.followers)}` : '-';
    const cost = cartItem.cost ? `${currencySymbol}${cartItem.cost}` : '-';
    const { platform, influencerId } = cartItem;

    return (
        <div className={styles.barWrapper}>
            <Image
                src={influencerImage?.image.avatar_thumb.cached_url}
                alt="Influencer"
                className={styles.influencerImage}
            />
            <div className={styles.details}>
                <div className={styles.row}>
                    <div className={styles.column}>
                        <span className={cn(styles.value, styles.small)}>{name}</span>
                        <div className={styles.row}>
                            <span className={cn(styles.value, styles.large, { [styles.ghostValue]: isOfferExists })}>
                                {cost}
                            </span>
                            {!readOnly && (
                                <div className={styles.priceInputWrapper}>
                                    <div>{currencySymbol}</div>
                                    <input
                                        ref={inputRef}
                                        type="number"
                                        className={styles.priceInput}
                                        placeholder="Offer"
                                        onChange={(e) => {
                                            if (!influencerId || typeof setPriceOffer !== 'function') {
                                                return;
                                            }
                                            const price = e.target.value !== '' ? Number(e.target.value) : null;
                                            setPriceOffer({ influencerId, price, platform });
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className={styles.statsContainer}>
                    <div className={styles.iconContainer}>
                        <PlatformIcon className={styles.icon} />
                    </div>
                    <span className={cn(styles.value, styles.small)}>{followers}</span>
                </div>
            </div>
        </div>
    );
};

export default BookingCartItemRow;
